var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.2001 2.39999C2.77575 2.39999 2.36878 2.56856 2.06873 2.86862C1.76867 3.16868 1.6001 3.57565 1.6001 3.99999C1.6001 4.42434 1.76867 4.83131 2.06873 5.13136C2.36878 5.43142 2.77575 5.59999 3.2001 5.59999H12.8001C13.2244 5.59999 13.6314 5.43142 13.9315 5.13136C14.2315 4.83131 14.4001 4.42434 14.4001 3.99999C14.4001 3.57565 14.2315 3.16868 13.9315 2.86862C13.6314 2.56856 13.2244 2.39999 12.8001 2.39999H3.2001Z",
    fill: "#09090B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.3999 6.39999H13.5999V12C13.5999 12.4243 13.4313 12.8313 13.1313 13.1314C12.8312 13.4314 12.4242 13.6 11.9999 13.6H3.9999C3.57556 13.6 3.16859 13.4314 2.86853 13.1314C2.56847 12.8313 2.3999 12.4243 2.3999 12V6.39999ZM6.3999 8.79999C6.3999 8.58782 6.48419 8.38434 6.63422 8.23431C6.78425 8.08428 6.98773 7.99999 7.1999 7.99999H8.7999C9.01208 7.99999 9.21556 8.08428 9.36559 8.23431C9.51562 8.38434 9.5999 8.58782 9.5999 8.79999C9.5999 9.01217 9.51562 9.21565 9.36559 9.36568C9.21556 9.51571 9.01208 9.59999 8.7999 9.59999H7.1999C6.98773 9.59999 6.78425 9.51571 6.63422 9.36568C6.48419 9.21565 6.3999 9.01217 6.3999 8.79999Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/Archive.88a176f3f533cdd09d9fc85f1c528d98.svg";
export { ForwardRef as ReactComponent };